import { FC, useCallback } from 'react';

import { TextField, TextFieldProps } from '@mui/material';

//
//

export type AppInputBaseProps = TextFieldProps & {};

//

export const AppInputBase: FC<AppInputBaseProps> = ({ children, size = 'medium', ...props }) => {
  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      props?.onChange?.(event);
    },
    [props]
  );

  // Fixe for input type number
  const onKeyDown = useCallback(
    (ev: React.KeyboardEvent<HTMLInputElement>) => {
      if (
        props.type === 'number' &&
        // TODO: Replace deprecated method
        ((ev.which !== 8 && ev.which !== 0 && ev.which < 48) || ev.which > 57)
      ) {
        ev.preventDefault();
      }
    },
    [props.type]
  );

  //

  return (
    <TextField
      size={size}
      onChange={onChange}
      slotProps={{
        formHelperText: {
          style: {
            marginLeft: 0,
          },
        },
      }}
      onKeyDown={onKeyDown}
      InputProps={{ autoComplete: props.type === 'number' ? 'off' : 'on' }}
      {...props}
    >
      {children}
    </TextField>
  );
};
